import React, {useState} from "react";
import InvoicesList from "./InvoicesList";


const RecentInvoices = ({
  invoices,
  isSuperMiddleman
}) => {

  const [ invoicesToRender, setInvoicesToRender ] = useState(JSON.parse(invoices));


  return <div className="font-size-14px">
    <InvoicesList
      invoices={invoicesToRender}
      setInvoices={setInvoicesToRender}
      invoicesAnimationDivider={invoicesToRender.length}
      isSuperMiddleman={isSuperMiddleman}
    />
  </div>
};

export default RecentInvoices;